export default __webpack_public_path__ + "static/media/fb_messenger.e0e894c6.svg";